/// <reference path="../../../WebUI/typings/tsd.d.ts" />
import * as React from "react";
import * as ReactDOM from "react-dom";
import {DialogBase} from "./DialogBase";
import * as Views from "../Views/ProgressPanel";
import { Resources } from "../Resources/Intercom.Resources.DevPortal";

export class ProgressDialog extends DialogBase {
    private options: ProgressDialogOptions;

    constructor(options: ProgressDialogOptions) {
        super();
        this.options = $.extend({}, DefaultProgressDialogOptions, options);
    }

    protected render(): void {
        var props: Views.ProgressPanelProps = {
            message: this.options.message
        };
        var element = React.createElement(Views.ProgressPanel, props);
        ReactDOM.render(element, this.$el[0], () => {
            this.init();
        });
    }

    protected init(): void {
        // Call base class method to complete initialization.
        super.init();
    }

    /** Static method for displaying a simple message. */
    public static show(message: string): ProgressDialog {
        var dialog = new ProgressDialog({ message: message });
        dialog.showDialog();
        return dialog;
    }
}

export interface ProgressDialogOptions {
    message?: string;
}

var DefaultProgressDialogOptions: ProgressDialogOptions = {
    message: Resources.dialogPleaseWait
};




// WEBPACK FOOTER //
// ./Client/Dialogs/ProgressDialog.ts